const StarCheckSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 44}`}
      height={`${height || 44}`}
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1608 1.18241C20.7253 -0.394137 23.2747 -0.394134 24.8392 1.18241L29.9935 6.37622C30.4954 6.88197 31.1232 7.24448 31.8122 7.42626L38.8873 9.29307C41.0349 9.85972 42.3096 12.0675 41.7265 14.2107L39.8057 21.2714C39.6186 21.9589 39.6186 22.6839 39.8057 23.3714L41.7265 30.4321C42.3096 32.5753 41.0349 34.7831 38.8873 35.3497L31.8122 37.2165C31.1232 37.3983 30.4954 37.7608 29.9935 38.2666L24.8392 43.4604C23.2747 45.0369 20.7253 45.0369 19.1608 43.4604L14.0065 38.2666C13.5046 37.7608 12.8767 37.3983 12.1878 37.2165L5.1127 35.3497C2.96511 34.7831 1.69043 32.5752 2.27348 30.4321L4.19433 23.3714C4.38138 22.6839 4.38137 21.9589 4.19433 21.2714L2.27348 14.2107C1.69042 12.0675 2.96511 9.85972 5.1127 9.29307L12.1878 7.42626C12.8767 7.24448 13.5046 6.88197 14.0065 6.37622L19.1608 1.18241Z"
        fill={color}
      />
      <path
        d="M30 16L19 27L14 22"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StarCheckSvg;
